import PropTypes from 'prop-types';
import { MapGeometryShape } from '../../map/models/MapGeometry';
import { RouteShape } from '../../mission/models/Route';
import { WorkzoneShape } from '../../mission/models/Workzone';
import { ObstacleShape } from '../../mission/models/Obstacle';
import { JurisdictionShape } from '../../contact/models/Jurisdiction';
import { FindingShape } from '../../finding/models/Finding';
import { RightOfWayShape } from '../../mission/models/RightOfWay';
import { UrbanAreaShape } from '../../mission/models/UrbanArea';
import { AirportShape } from '../../mission/models/Airport';
import { PipelineCenterlineShape } from '../../mission/models/PipelineCenterline';
import { ClientCategoryShape } from '../../client/models/ClientCategory';

const Patrol = {
  id: PropTypes.number,
  missionName: PropTypes.string,
  clientName: PropTypes.string,
  startedAt: PropTypes.string,
  startedAtTimezone: PropTypes.string,
  completedAt: PropTypes.string,
  completedAtTimezone: PropTypes.string,
  transferredAt: PropTypes.string,
  transferredAtTimezone: PropTypes.string,
  flightDuration: PropTypes.number,
  coveragePercentage: PropTypes.number,
  flightPath: MapGeometryShape,
  findings: PropTypes.arrayOf(FindingShape),
  pilot: PropTypes.object,
  routes: PropTypes.arrayOf(RouteShape),
  workzones: PropTypes.arrayOf(WorkzoneShape),
  obstacles: PropTypes.arrayOf(ObstacleShape),
  jurisdictions: PropTypes.arrayOf(JurisdictionShape),
  rightOfWays: PropTypes.arrayOf(RightOfWayShape),
  urbanAreas: PropTypes.arrayOf(UrbanAreaShape),
  airports: PropTypes.arrayOf(AirportShape),
  centerlines: PropTypes.arrayOf(PipelineCenterlineShape),
  inspectionDuration: PropTypes.number,
  isMissionDeleted: PropTypes.bool,
  isMissionShared: PropTypes.bool,
  isDeleted: PropTypes.bool,
  publishedAt: PropTypes.string,
  publishedAtTimezone: PropTypes.string,
  reviewedAt: PropTypes.string,
  clientCategories: PropTypes.arrayOf(ClientCategoryShape),
};

export const PatrolShape = PropTypes.shape(Patrol);
export const PatrolExact = PropTypes.exact(Patrol);
